import {ChangeDetectorRef, Component, forwardRef} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {appInjector} from "../../../index";
import {AddressFormComponent} from "../../../core/visbos-core/ui/forms/address-form/address-form.component";
import {Supplier} from "../../../shared/view-model/crm/supplier.type";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {SessionActions} from "../../../shared/actions";
import {Client} from "../../../shared/view-model/crm/client.type";
import {ClientService} from "../../services/client.service";
import {MessageType} from "../../../shared/redux-store/session";

@Component({
  selector: 'vb-client-form',
  templateUrl: './client-form.component.html',
  styleUrls: ['./client-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => ClientFormComponent)}]
})
export class ClientFormComponent extends AbstractVisbosControl<Client, FormGroup> {


  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
              private clientService: ClientService) {
    super(fb, cd, sessionActions);
  }

  buildControlContent(): FormGroup {
    return ClientFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      name: [null, Validators.required],
      administration_unit_id: [null, Validators.required],
      account_id: [null],
      address: AddressFormComponent.initControl(fb),
      //billing_address: AddressFormComponent.initControl(fb),
      business_relations: fb.array([])
    });

  }

  public setDefaultValues(item?: Client): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      name: this.setValue(item, 'name')
    };
  }

  reset(fullReset: boolean = false): any {
    let br = (<FormArray>this.control.get('business_relations'));

    br.controls = [];
    //br.push(BusinessRelationsFormComponent.initControl(this.fb));

    super.reset(fullReset);
  }

  private initBusinessRelation(item?) {
    //TODO: Implement
    /*return {
        cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
        relation_source_id: this.setValue(item, 'relation_source_id'),
        relation_source_type: this.setValue(item, 'relation_source_type'),
        relation_target_id: this.setValue(item, 'relation_target_id'),
        relation_target_type: this.setValue(item, 'relation_target_type'),
        relation_type_id: this.setValue(item, 'relation_type_id'),
        relation_type_type: this.setValue(item, 'relation_type_type')
      };*/
  }

  private transformToOutput(formData): { supplierInput, relationsData } {

    let clientInput = Object.assign({}, formData);
    delete clientInput.business_relations;
    let relationsData = null;

    if (formData.business_relations) {
      clientInput.business_relations = [...formData.business_relations.map(rel => rel.relation)];
      relationsData = [...formData.business_relations.map(rel => rel.relation_data)];
    }

    let result = {
      supplierInput: clientInput,
      relationsData: relationsData
    };

    return result;
  }

  createOrUpdateClient(data?) {
    let clientData = this.transformToOutput(data ? data : this.control.value);

    if (this.item) {
      this.clientService.updateClient(this.item.cuid, clientData.supplierInput, clientData.relationsData)
        .toPromise()
        .then((res: any) => {
            this.sessionActions.pushMessage('Klient erfolgreich geändert.', MessageType.SUCCESS, 'Klientenverwaltung');
            this.reset(true);
          },
          err => this.sessionActions.throwError(err, 'Fehler beim Ändern des Klienten!'));
    } else {
      this.clientService.addClient(clientData.supplierInput, clientData.relationsData)
        .toPromise()
        .then((res: any) => {
            this.sessionActions.pushMessage('Klient erfolgreich angelegt.', MessageType.SUCCESS, 'Klientenverwaltung');
            this.reset(true);
          },
          err => this.sessionActions.throwError(err, 'Fehler beim Anlegen des Klienten!'));
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/crm/client/client-form/client-form.component.ts